import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";
import { SERVICE_NAME } from "@zapier/utils";

export enum AppSearchInteractionOption {
  AddConnection = "add_connection",
  Keyword = "keyword",
  LatestPublic = "latest_public",
  Other = "other",
}

export function useEmitAppSearchInteractionEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (optionSelected: AppSearchInteractionOption) => {
      emitUserInteractionEvent({
        accountId,
        eventAction: "click",
        interactionName: UserInteractionName.AppSearch,
        optionSelected,
        systemName: SERVICE_NAME,
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
